// userActions.js
import axios from 'axios';
import Swal from 'sweetalert2';
import { encryptStorage } from './../../utils/storage';


// Action types
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const SET_LOADING = 'SET_LOADING';
export const LOGIN_TYPE = 'LOGIN_TYPE';

export const setLoading = (isLoading) => ({
    type: SET_LOADING,
    payload: isLoading,
});


export const loginUser = (userData, navigate) => async (dispatch) => 
{
    // console.log(userData)
    dispatch(setLoading(true));
    try {
        const response = await axios.get(`https://api.thamesbankinsurance.co.uk/api/getlogininfo?pRef=${userData.referenceCode}&pCode=${userData.postCode}&pReturn=${userData.process}`, {headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Headers': 'Content-Type',
        }});
        console.log('test-19-2',userData)
        // console.log(response.data.Result.Rows.Row.Col)
        if(response.data.Result.Rows.Row.Col?.["@value"] === 'Login Success'){
            await axios.get(`https://api.thamesbankinsurance.co.uk/api/getpaymentportalinfo?pRef=${userData.referenceCode}&pCode=${userData.postCode}&pReturn=${userData.process}`)
            .then((response) => {
                if(response.data.PaymentPortalInfo.Res === "Login Failed"){
                    Swal.fire({
                        title: 'Error!',
                        text: 'A quote for the details you entered could not be found.',
                        icon: 'error',
                    });
                    dispatch(setLoading(false));
                    return;
                } else{
                    // console.table(response.data)
                    encryptStorage.setItem('b68f38dbe5a2', response.data);
                    localStorage.setItem('loginData', JSON.stringify(userData));
                    dispatch({
                        type: LOGIN_SUCCESS,
                        payload: response.data.PaymentPortalInfo,
                        isAuthenticated: true,
                    });
                    console.log(response.data.PaymentPortalInfo.Res)
                    dispatch({
                        type: LOGIN_TYPE,
                        payload: userData.process,
                        isAuthenticated: true,
                    });
                    navigate('/product', { replace: true });
                    dispatch(setLoading(false));
                }
            });
        } else{
            Swal.fire({
                title: 'Error!',
                text: 'A quote for the details you entered could not be found.',
                icon: 'error',
            });
            dispatch(setLoading(false));
            return;
        }
    } catch (error) {
        dispatch(setLoading(false));
        dispatch({
            type: LOGIN_FAILURE,
            payload: error,
        });
        Swal.fire({
            title: 'Error',
            text: error,
            icon: "error"
        });
    }
};


export const UserDetails = () => async (dispatch) =>{
    // const token = encryptStorage.getItem('b68f38dbe5a2');
    const referenceCode = localStorage.getItem('loginData');
    const refData = JSON.parse(referenceCode);
    dispatch(setLoading(true));
    try{
        const response = await axios.get(`https://api.thamesbankinsurance.co.uk/api/getpaymentportalinfo?pRef=${refData.referenceCode}&pCode=${refData.postCode}&pReturn=${refData.process}`, {headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Headers': 'Content-Type'
        }});
        console.log("19-2",response)
        dispatch({
            type: LOGIN_SUCCESS,
            payload: response.data.PaymentPortalInfo,
            isAuthenticated: true,
        });
        dispatch(setLoading(false));
    }catch (error) {
        dispatch(setLoading(false));
        dispatch({
            type: LOGIN_FAILURE,
            payload: error,
        });
        encryptStorage.removeItem('b68f38dbe5a2');
        window.location.replace("/"); 
        window.location.reload();
    }
}





export const logoutUser = () => (dispatch) => {
    encryptStorage.removeItem('b68f38dbe5a2');
    localStorage.removeItem('loginData');
    dispatch({
        type: LOGOUT,
    });
    Swal.fire({
        title: "Successfully logged out",
        icon: "success",
        buttons: false,
        timer: 1500,
    })
    window.location.replace("/"); 
    window.location.reload();
    
};


// Check for a stored token during application initialization
export const checkAuth = (navigate) => (dispatch) => {
    const token = encryptStorage.getItem('b68f38dbe5a2');
    if (token) {
        dispatch(UserDetails());
    } else {
        encryptStorage.removeItem('b68f38dbe5a2');
        // location.replace("/login"); 
        // window.location.reload();
        navigate('/', { replace: true });
    }
};